import { useEffect, useState } from 'react';
import { Oferta } from '../services/ofertas-service/models/ofertas';

export const capitalizeSentence = (string: string): string => {
	return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatPrecio = (precio: number): string => {
	const formatPrecio = precio.toString();
	if (formatPrecio.length <= 3) {
		return formatPrecio;
	} else {
		return formatPrecio.slice(0, -3) + '.' + formatPrecio.slice(-3);
	}
};

export const getEtiquetaDgt = (etiqueta: string) => {
	const etiquetaC =
		'https://cdn.volkswagen.es/repository/app/vw-match/assets/icon/stock_etiqueta_c.png';
	const etiquetaEco =
		'https://cdn.volkswagen.es/repository/app/vw-match/assets/icon/stock_etiqueta_eco.png';
	const etiquetaZero =
		'https://cdn.volkswagen.es/repository/app/vw-match/assets/icon/stock_etiqueta_0.png';

	let imageEtiqueta: string;

	switch (etiqueta) {
		case 'C':
			imageEtiqueta = etiquetaC;
			break;
		case '0':
			imageEtiqueta = etiquetaZero;
			break;
		case 'ECO':
			imageEtiqueta = etiquetaEco;
			break;
		default:
			imageEtiqueta = etiquetaC;
			break;
	}

	return imageEtiqueta;
};

export const useTransformNumberFormat = (number: string | number) => {
	const [transformedNumber, setTransformedNumber] = useState<string>('');

	useEffect(() => {
		const decimals = number.toString().split('.');
		const numerals = decimals.shift().split('');
		const firstTwoDecimals = decimals.toString().slice(0, 2);

		let aux = [];

		while (numerals.length > 0) {
			aux.unshift(numerals.splice(-3, 3).join(''));
		}
		if (decimals.length <= 0) {
			setTransformedNumber(aux.join('.') + ',00');
		} else if (decimals[0].length === 1) {
			setTransformedNumber(aux.join('.') + ',' + decimals.toString() + '0');
		} else {
			setTransformedNumber(aux.join('.') + ',' + firstTwoDecimals.toString());
		}
	}, []);

	return transformedNumber;
};

export const getFinanciacionType = (oferta: Oferta): string | undefined => {
	if (
		oferta.myWay.activo === null &&
		oferta.myWay.servicio === null &&
		oferta.myRenting === null
	) {
		return undefined;
	}

	if (
		oferta.myWay.activo === 1 &&
		(oferta.myWay.servicio === 1 || oferta.myWay.servicio === 0)
	) {
		return 'My Way';
	}

	return 'My Renting';
};
